import makerCheckerServices from '@/services/makerCheckerServices';

export default {
  namespaced: true,
  state: {
    pendingChecks: [],
    requestedChecks: [],
    pagination: {
      page: 1,
      pageSize: 30,
      total: 0
    }
  },
  mutations: {
    SET_PENDING_CHECKS(state, { data, pagination }) {
      state.pendingChecks = data;
      if (pagination) {
        state.pagination = pagination;
      }
    },
    SET_REQUESTED_CHECKS(state, { data, pagination }) {
      state.requestedChecks = data;
      if (pagination) {
        state.pagination = pagination;
      }
    }
  },
  actions: {
    async getPendingChecks({ commit }, params) {
      try {
        const response = await makerCheckerServices.getPendingChecks(params);
        commit('SET_PENDING_CHECKS', response);
        return response;
      } catch (error) {
        throw error;
      }
    },

    async getRequestedChecks({ commit }, params) {
      try {
        const response = await makerCheckerServices.getRequestedChecks(params);
        commit('SET_REQUESTED_CHECKS', response);
        return response;
      } catch (error) {
        throw error;
      }
    },

    async getCheckDetails(_, id) {
      try {
        const response = await makerCheckerServices.getCheckDetails(id);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async getCheckItemDetails(_, { itemType, itemId }) {
      try {
        const response = await makerCheckerServices.getCheckItemDetails({ itemType, itemId });
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async updateCheckStatus(_, { id, status, comments }) {
      try {
        const response = await makerCheckerServices.updateCheckStatus(id, status, comments);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
}; 